import * as Scrivito from "scrivito";

const FormWidget = Scrivito.provideWidgetClass("FormWidget", {
  attributes: {
    formPages: ["widgetlist", { only: ["FormPageWidget"] }],
    introPage: ["widgetlist", { only: "IntroPageWidget" }],
    outroPage: ["widgetlist", { only: "OutroPageWidget" }],
    csvColumns: "stringlist",
    emailCSVReceiver: "string",
    emailTitle: "string",
    confirmationEmailText: "html",
  },
});
export default FormWidget;
